import { extend } from '@spazious/dollhouse-fiber';

import {
  AnnotationNodeImpl,
  CameraPathNodeImpl,
  DecorationNodeImpl,
  FAreaNodeImpl,
  FCompositionNodeImpl,
  FGroupNodeImpl,
  FPolygonNodeImpl,
  FurnitureNodeImpl,
  MeasurementNodeImpl,
} from './nodes/index.js';

extend({
  furniture: FurnitureNodeImpl,
  fcomposition: FCompositionNodeImpl,
  fgroup: FGroupNodeImpl,
  fpolygon: FPolygonNodeImpl,
  farea: FAreaNodeImpl,
  camerapath: CameraPathNodeImpl,
  measurement: MeasurementNodeImpl,
  decoration: DecorationNodeImpl,
  annotation: AnnotationNodeImpl,
});

declare global {
  namespace JSX {
    interface IntrinsicElements {
      fcomposition: GraphNode<FCompositionNodeImpl>;
      furniture: GraphNode<FurnitureNodeImpl>;
      fgroup: GraphNode<FGroupNodeImpl>;
      fpolygon: GraphNode<FPolygonNodeImpl>;
      farea: GraphNode<FAreaNodeImpl>;
      camerapath: GraphNode<CameraPathNodeImpl>;
      measurement: GraphNode<MeasurementNodeImpl>;
      decoration: GraphNode<DecorationNodeImpl>;
      annotation: GraphNode<AnnotationNodeImpl>;
    }
  }
}
